import {NgModule} from "@angular/core";
import {RouterModule} from "@angular/router";
import {AdminAppComponent} from "./admin-app.component";
import {AuthGuard} from "../shared/_guards/auth.guard";
import {HomeComponent} from "./+home/home.component";
import {NewsComponent} from "./+news/news.component";
import {UsersComponent} from "./+users/users.component";
import {AboutComponent} from "./+about/about.component";

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'administration',
        canActivate : [AuthGuard],
        component: AdminAppComponent,
        children : [
          {
            path: '',
            redirectTo: 'news',
            pathMatch: 'full'
          },
          {
            path: 'home',
            component: HomeComponent
          },
          {
            path: 'news',
            component: NewsComponent
          },
          {
            path: 'users',
            component: UsersComponent
          },
          {
            path: 'about',
            component: AboutComponent
          }
        ]
      }
    ])
  ]
})
export class AdminAppRouting {

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/+admin-app/admin-app-routing.module.ts